import apiFetch from '../apiFetch'

export default function (values, token) {
  return apiFetch({endPoint: `Ruta/getClientesFiltrados`, method: 'POST', body: values, token: token})
}
